var map = {
	"./add-large.svg": "5bAM",
	"./add.svg": "HDdA",
	"./album.svg": "CpTG",
	"./arrow-down.svg": "/7LY",
	"./arrow-left.svg": "tqch",
	"./arrow-right.svg": "yCD8",
	"./check.svg": "LI6s",
	"./close.svg": "srjS",
	"./cover.svg": "Oa3d",
	"./delete.svg": "eXS7",
	"./edit.svg": "TIm7",
	"./favourite.svg": "hdf1",
	"./help.svg": "ijvn",
	"./hidden.svg": "CCom",
	"./isFavourite.svg": "IRKv",
	"./logout.svg": "fmgo",
	"./search-small.svg": "qM9u",
	"./search.svg": "dZHa",
	"./settings.svg": "6g1Y",
	"./upload-large.svg": "+ETy",
	"./upload.svg": "QOvy",
	"./user-large.svg": "/JrC",
	"./user.svg": "Km1V",
	"./visible.svg": "CzFf",
	"./write.svg": "oGX+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/tJe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons nonrecursive \.svg$
// module id = /tJe
// module chunks = 4